import React, { useState, useMemo } from 'react';
import {
    Button, TextField, Typography, Dialog, DialogTitle, DialogContent, Grid, Tooltip, IconButton
} from '@material-ui/core';
import { Edit, Delete } from '@material-ui/icons';
import { DataGrid } from '@mui/x-data-grid';
import { Autocomplete } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import Swal from '#/swal';
import Form from './Form';
import { getState } from '../../store';
import { filterArrayByRole } from '#/permissions';
import { useProperties, useDeleteProperty } from '~/properties';

const useStyles = makeStyles({
    dataGrid: {
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus': {
            outline: 'none'
        }
    },
    redButton: {
        color: '#fff',
        backgroundColor: '#DB2828'
    }
});

const Properties = props => {

    const { role } = getState().auth;

    const [modalOpen, setModalOpen] = useState(false);
    const [initialValues, setInitialValues] = useState(null);
    // const showLoader = useLoader();
    const classes = useStyles();
    const { data, isLoading } = useProperties();
    const { mutate: deleteProperty } = useDeleteProperty();

    const isAdmin = role === 'admin';


    const handleDelete = async property => {
        const { value } = await Swal.fire.warning();
        if (value) {
            const result = await Swal.fire.warning({
                title: 'Are you REALLY REALLY sure?',
                text: `Seriously! This will remove ${property.name} from the database!`
            });

            if (result.value) deleteProperty(property.id);
        }
    };

    const columns = useMemo(() => [
        {
            renderHeader: () => <strong>Name</strong>,
            field: 'name',
            flex: 3
        },
        {
            field: 'amenities',
            renderHeader: () => <strong>Amenities</strong>,
            renderCell: ({ row }) => (
                <Autocomplete
                    options={amenitySelectOptions(role)}
                    getOptionLabel={option => option.text}
                    renderInput={
                        params => <TextField
                            {...params}
                            InputProps={{
                                ...params.InputProps,
                                disableUnderline: true
                            }}
                            label='Manage Amenities'
                        />
                    }
                    fullWidth
                    onChange={(e, value) => props.history.push(`/properties/${row.id}/${value.value}`)}
                />
            ),
            flex: 1
        },
        {
            field: 'reports',
            renderHeader: () => <strong>Reports</strong>,
            renderCell: ({ row }) => (
                <Autocomplete
                    options={reportSelectOptions(role)}
                    getOptionLabel={option => option.text}
                    renderInput={
                        params => <TextField
                            {...params}
                            label='Select Report'
                            InputProps={{
                                ...params.InputProps,
                                disableUnderline: true
                            }}
                        />}
                    fullWidth
                    onChange={(e, value) => props.history.push(`/properties/${row.id}/reports/${value.value}`)}
                />
            ),
            flex: 1

        },
        {
            field: 'actions',
            renderHeader: () => <strong>Actions</strong>,
            renderCell: ({ row }) => (

                <div>
                    <Tooltip title='Edit' onClick={() => {
                        setInitialValues(row);
                        setModalOpen(true);
                    }}>
                        <IconButton>
                            <Edit />
                        </IconButton>
                    </Tooltip>
                    {isAdmin && (
                        <Tooltip title='Delete'>
                            <IconButton onClick={ () => handleDelete(row) }>
                                <Delete />
                            </IconButton>
                        </Tooltip>
                    )}
                </div>
                // <ButtonGroup size='medium' disableElevation>
                //     <Button
                //         children='Edit'
                //         onClick={() => {
                //             setInitialValues(row);
                //             setModalOpen(true);
                //         }}
                //     />
                //     <Button
                //         className={classes.redButton}
                //         children='Delete'
                //         onClick={() => handleDelete(row)}
                //     />
                // </ButtonGroup>
            ),
            flex: 1,
            align: 'right',
            headerAlign: 'right'

        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ], []);

    return (
        <div>
            <Grid container justifyContent='space-between' style={{ marginBottom: '10px' }}>

                <Grid item>
                    <Typography variant='h4'>
                        Properties
                    </Typography>

                </Grid>


                <Grid item>

                    {isAdmin && (
                        <div>
                            <Button
                                variant='contained'
                                color='primary'
                                children='New Property'
                                onClick={() => {
                                    setInitialValues(null);
                                    setModalOpen(true);
                                }}
                            />
                        </div>
                    )}
                </Grid>
            </Grid>


            <DataGrid
                className={classes.dataGrid}
                loading={isLoading}
                columns={columns}
                rows={data || []}
                autoHeight
                disableSelectionOnClick
                hideFooterSelectedRowCount
                hideFooterPagination
            />

            <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
                <DialogTitle>
                    {initialValues ? 'Edit' : 'New'} property
                </DialogTitle>
                <DialogContent>
                    <Form setModalOpen={setModalOpen} initialValues={initialValues} />
                </DialogContent>
            </Dialog>

        </div>
    );
};

const reportSelectOptions = role => filterArrayByRole([
    {
        value: 'delinquencies',
        text: 'Delinquency Report'
        // rules: ['admin', /legal/]
    },
    // {
    //     value: 'price-list',
    //     text: 'Price List'
    // },
    {
        value: 'pricing',
        text: 'Unit Pricing / Availabilities'
        // rules: ['admin']

    },
    {
        value: 'matrix',
        text: 'Matrix View'
        // rules: ['admin']

    },
    {
        value: 'matrix-and-leasing',
        text: 'Matrix v2'
        // rules: ['admin']

    },
    {
        value: 'renewals',
        text: 'Renewals'
    }
],
role
);

const amenitySelectOptions = role => filterArrayByRole(
    [
        {
            value: 'orders',
            text: 'Manage Orders / Amenity Notes'
            // rules: ['admin']

        },
        {
            value: 'amenity-config',
            text: 'Manage Amenity Config',
            rules: ['admin']
        },
        {
            value: 'amenity-report',
            text: 'Amenity Report',
            rules: ['admin', 'regional_admin', 'user']
        }
    ],
    role
);


export default Properties;
